import { Divider, Typography, Grid } from '@mui/material';

import { SummarySectionContainer } from '@components/molecules/cpdEnrollment/confirmAllInformation/style';

type SectionSummaryProps = {
  title: string;
  items: Record<string, string>;
};

const SectionSummary = ({ title, items }: SectionSummaryProps) => (
  <SummarySectionContainer>
    <Typography className="summary-section-title">{title}</Typography>
    <Divider className="divider" />
    <Grid container alignItems="baseline" columnSpacing={2}>
      {Object.entries(items).map(([key, value]) => (
        <>
          <Grid item xs={6} md={4}>
            <Typography className="text text-label">{key}:</Typography>
          </Grid>
          <Grid item xs={6} md={8}>
            <Typography className="text text-value">{value}</Typography>
          </Grid>
        </>
      ))}
    </Grid>
  </SummarySectionContainer>
);

export default SectionSummary;
